(() => {
  class HxNadScience extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      try { this.points = JSON.parse(this.querySelector('[data-nad-points]').textContent); } catch { return; }
      if (this.points.length !== 3) return;
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.percent = new Intl.NumberFormat(this.dataset.locale || 'fr', {style:'percent', maximumFractionDigits:0, signDisplay:'exceptZero'});
      this.selectors = [...this.querySelectorAll('[data-nad-select]')];
      this.curve = this.querySelector('[data-nad-curve]');
      this.selected = -1;
      const events = {signal:this.abort.signal};
      this.selectors.forEach(button => button.addEventListener('click', () => this.select(Number(button.dataset.nadSelect)), events));
      this.querySelector('.hx-nad-timeline').addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? 2 : Math.max(0,Math.min(2,this.selected + (event.key === 'ArrowRight' ? 1 : -1)));
        this.select(next);
        this.querySelector(`.hx-nad-timeline [data-nad-select="${next}"]`).focus();
      }, events);
      this.curve.addEventListener('pointerdown', event => {
        if (event.target.closest('button')) return;
        const bounds = this.curve.getBoundingClientRect();
        if (!bounds.width) return;
        const x = (event.clientX - bounds.left) / bounds.width * 660;
        const closest = this.points.reduce((index,point,next,points) => Math.abs(point.x-x) < Math.abs(points[index].x-x) ? next : index,0);
        this.select(closest);
      }, {...events,passive:true});
      this.querySelector('[data-nad-replay]').addEventListener('click', () => this.replay(), events);
      this.select(1);
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.replay(); this.observer.disconnect();
      }, {threshold:.25});
      this.observer.observe(this);
    }
    select(index) {
      const point = this.points[index];
      if (!point || this.selected === index) return;
      this.selected = index; this.dataset.nadSelected = index;
      this.selectors.forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.nadSelect) === index)));
      const value = this.percent.format(point.increase / 100);
      this.querySelector('[data-nad-number]').textContent = value;
      this.querySelector('[data-nad-value]').textContent = value;
      this.querySelector('[data-nad-accessible]').textContent = point.summary;
      this.querySelector('[data-nad-tooltip-label]').textContent = point.label;
      const period = this.querySelector('[data-nad-period]');
      if (period) period.textContent = point.label;
      const tooltip = this.querySelector('[data-nad-tooltip]');
      tooltip.style.setProperty('--nad-x',`${point.x/660*100}%`);
      tooltip.style.setProperty('--nad-y',`${point.y/308*100}%`);
      const guide = this.querySelector('[data-nad-guide]');
      guide.setAttribute('x1',point.x); guide.setAttribute('x2',point.x);
      ['ring','dot'].forEach(target => {
        const dot = this.querySelector(`[data-nad-${target}]`);
        dot.setAttribute('cx',point.x); dot.setAttribute('cy',point.y);
      });
      const placebo = this.querySelector('[data-nad-placebo-dot]');
      placebo.setAttribute('cx',point.x); placebo.setAttribute('cy',point.placeboY);
    }
    replay() {
      this.classList.add('is-visible');
      this.animations?.forEach(animation => animation.cancel());
      if (this.reduced.matches) return;
      this.animations = [
        this.querySelector('[data-nad-line]').animate([{strokeDashoffset:1000},{strokeDashoffset:0}],{duration:1150,easing:'cubic-bezier(.2,.65,.3,1)'}),
        this.querySelector('[data-nad-reference]').animate([{opacity:0},{opacity:1}],{duration:900,easing:'ease-out'}),
        this.querySelector('[data-nad-area]').animate([{opacity:0},{opacity:1}],{duration:1000,easing:'ease-out'})
      ];
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null; this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
    }
  }
  if (!customElements.get('hx-nad-science')) customElements.define('hx-nad-science',HxNadScience);
})();
